export default "/images/logout-icon.svg?e4b0da303b1e420bd9e574fb47942243";